import { IconButton, TableCell, TableRow, Chip } from '@mui/material';
import { MagnifyingGlass } from '@phosphor-icons/react';
import { Link } from 'react-router';
import { Api } from '../../api';
import { Model } from '../../models';
import { iriToId } from '../../util';
import { format } from 'date-fns';

type Props = {
  team: Api.OrganisationTeam.V_UserSub;
};

export default function B2BTeamsRow({ team }: Props) {
  return (
    <TableRow
      component={Link}
      to={`/users?organisationTeam=${encodeURIComponent(iriToId(team['@id']))}&activeSubscription=true`}
      sx={{
        cursor: 'pointer',
        textDecoration: 'none',
        '&:hover': { backgroundColor: 'action.hover' },
      }}
    >
      <TableCell>
        {team.organisation.name} - {team.name}
      </TableCell>
      <TableCell>{format(team.programStartDate, 'd MMM yyyy')}</TableCell>
      <TableCell>
        <Chip
          label={
            team.programProgress
              ? Model.ProgramProgress.getStatusLabel(team.programProgress)
              : '-'
          }
          color={
            team.programProgress
              ? Model.ProgramProgress.getStatusColor(team.programProgress)
              : 'default'
          }
        />
      </TableCell>
      <TableCell>{team.activeMemberCount}</TableCell>
      <TableCell align="center">
        <IconButton
          size="small"
          sx={{ color: '#667085', pointerEvents: 'none' }}
        >
          <MagnifyingGlass size={20} />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
